import { bootstrapApplication } from "@angular/platform-browser";
import { AppComponent } from "./app/app.component";
import { provideRouter } from "@angular/router";
import { provideHttpClient, withInterceptors } from "@angular/common/http";
import { routes } from "./app/app.routes";
import { provideAnimations } from '@angular/platform-browser/animations';
import { authInterceptor } from "./app/core/interceptors/auth.interceptor";
import { ErrorInterceptor } from "./app/core/interceptors/error.interceptor";

// Locale: habilitar formato en español para DatePipe / NumberPipe (sin cambiar el LOCALE_ID global)
import { registerLocaleData } from '@angular/common';
import localeEs from '@angular/common/locales/es';

registerLocaleData(localeEs);

bootstrapApplication(AppComponent, {
  providers: [
    provideRouter(routes),
    provideAnimations(),
    provideHttpClient(withInterceptors([authInterceptor, ErrorInterceptor]))
  ]
}).catch((err) => console.error(err));
